import { dataFetch } from '@lib/ggj-utils'

export default {

  // 获取用户信息
  async userInfo (params) {
    return dataFetch('/user-customer-web/api/account/userInfo', params)
  },

  // 发送验证码
  async sendCode (params) {
    return dataFetch('/user-customer-web/api/sms/send/v1', params)
  },

  // 获取账号注销常量定义接口
  async getConstants (params) {
    return dataFetch('/user-customer-web/api/account/cancel/getConstants', params)
  },
  // 账号注销前条件检查及结果
  async preCheckRules (params) {
    return dataFetch('/user-customer-web/api/account/cancel/preCheckRules', params)
  },

  // 账号注销最后一步，提交注销原因
  async submitReason (params) {
    return dataFetch('/user-customer-web/api/account/cancel/submitReason', params)
  },

  // 账号注销前-短信验证码校验
  async validateSms (params) {
    return dataFetch('/user-customer-web/api/account/cancel/validateSms', params)
  },


  // async checkInit (params) {
  //   return dataFetch('/risk-center/riskctrl/geetestValidateInit', params, {method: 'get'})
  // },
}
